import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import classNames from 'classnames';
import ReactGA from 'react-ga4';
import camelcaseKeys from 'camelcase-keys';
import {
  ALLOWED_CLIENT_IDS,
  ENV,
  LANDING_PAGE_URL,
  NOTIFICATION_URL,
  VBEE_DOMAIN,
} from '@src/configs';
import {
  COUNTRY,
  EVENT_TYPE,
  TIME_DELAY_CALL_API_GET_USER_INFO,
  UPDATE_ONLINE_STATUS_INTERVAL,
  VIETNAM_LOCATION,
} from '@src/constants';
import ROUTES from '@src/constants/route';
import {
  PING_INTERVAL,
  SYNTHESIS_STATUS,
  WS_TYPE,
  WS_ORDER_STATUS,
} from '@src/constants/websocket';
import {
  FREE_PACKAGE_CODES,
  MIGRATED_NAME_PACKAGE_CODES,
  PACKAGE_STUDIO_VERSION,
  PACKAGE_TYPE,
} from '@src/constants/package';
import CustomTypography from '@src/new-components/Typography';
import { BANNER_TYPE } from '@src/constants/banner';
import {
  checkAutoRenewalPackage,
  checkCustomPackage,
  checkFreePackage,
  checkLowCredits,
  checkOneTimePackage,
  checkPackageExpired,
  getPackageName,
  getParamsExpiringSoon,
  getPathPaymentWhenNotifyLowCredits,
  hasPackageExpiringSoon,
  isTopUpPackageCode,
} from '@src/services/package';
import { getCookie, removeCookie, setCookie } from '@src/utils/cookie';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@src/redux/actions';
import { STATUS_SURVEY } from '@src/constants/survey';
import ProcessHandler from '@src/components/ProcessHandler';
import Banners from '@src/containers/Banner';
import EventWidget from '@src/containers/TopPaidEvent/EventWidget';
import NotificationDialog from '@src/components/NotificationDialog';
import apis from '@src/apis';
import { DEVICE_STATUS } from '@src/constants/device';
import TransferIcon from '@src/assets/images/transfer-icon.svg';
import { Box, CircularProgress, useMediaQuery } from '@mui/material';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import { AFFILIATE_NOTIFICATION_TYPE } from '@src/constants/affiliate';
import { ORDER_STATUS } from '@src/constants/order';
import moment from 'moment';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import useCustomKeycloak from '@src/hooks/useCustomKeycloak';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { SUBSCRIPTION_PURCHASE_STATUS } from '@src/constants/subscription';
import { delay } from '@src/utils/delay';
import {
  useCheckDubbingRoute,
  useCheckEducatorsRoute,
  useCheckProjectRoute,
} from '@src/hooks/useCheckDubbingRoute';
import useWindowDimensions from '@src/hooks/useWindowDimensions';
import useUserInfo from '@src/hooks/useTtsUser';
import useCustomerSupportView from '@src/hooks/useCustomerSupportView';
import TitleProduct from '@src/components/TitleProduct';
import LimitedFeaturesDialog from '@src/components/Dialog/LimitedFeaturesDialog';
import {
  getUserUpdateCredits,
  getUserUpdateCreditsProcessWallet,
} from '@src/services/tts';
import { rollbackTrialUsage } from '@src/services/voiceTrial';
import {
  clearMoengageIdentity,
  identifyUser,
  trackConvertSuccess,
  trackOnboardingTaskCompleted,
} from '@src/services/moengage';
import useRemoveInjectedIframe from '@src/hooks/useRemoveInjectedIframe';
import useRedirectInvalidPaths from '@src/hooks/useRedirectInvalidPaths';
import useAutoRenewPriceAdjustment from '@src/hooks/useAutoRenewPriceAdjustment';
import {
  AUTO_APPLY_REFERRAL_PARAM,
  REFERRAL_CODE_PARAM,
} from '@src/constants/referral';
import { REDEEM_PARAM } from '@src/constants/redeem';
import { HAS_OPENED_REQUIRE_PROVIDE_EMAIL_DIALOG } from '@src/constants/email';
import {
  BLOCK_STATUS,
  CONVERTING_STATUS,
  PROJECT_PRODUCT,
} from '@src/constants/project';
import useIpLocation from '@src/hooks/useLocation';
import { COLOR } from '@src/styles/color';
import { isNumber } from 'lodash';
import i18n from '@src/languages';
import NotificationDialogV3 from '@src/components/NotificationDialogV3';
import RedeemDialog from '@src/containers/Referral/RedeemDialog';
import ReferralErrorDialog from '@src/containers/Referral/ReferralErrorDialog';
import { shouldShowWeeklyHighlights } from '@src/services/leaderboard';
import CommonDialog from '@src/new-components/Dialog/CommonDialog';
import useTotalCredits from '@src/hooks/useTotalCredits';
import theme from '@src/styles/theme';
import { checkUserHasProvidedEmail } from '@src/services/email';
import {
  isVideoSource,
  getAudioAdjustedBlockEndTime,
} from '@src/services/project';
import { loadAudioDurationFromUrl } from '@src/services/audio';
import { useMappingPackage } from '@src/hooks/useMappingPackage';
import OnboardingPopup from '@src/new-components/OnboardingPopup';
import useOnboardingPopup from '@src/hooks/useOnboardingPopup';
import useEducatorsSurveyPopup from '@src/containers/EducatorsHome/hooks/useEducatorsSurveyPopup';
import useEducatorsPopupChain from '@src/containers/EducatorsHome/hooks/useEducatorsPopupChain';
import usePostponedOnboardingTasks from '@src/containers/EducatorsHome/hooks/usePostponedOnboardingTasks';
import useProductMode from '@src/hooks/useProductMode';
import useEducatorsModeEnabled from '@src/containers/EducatorsHome/hooks/useEducatorsModeEnabled';
import { hasEducatorsSignupAnswer } from '@src/services/productMode';
import { PRODUCT_MODE } from '@src/constants/educators';
import useNotificationSSE from '@src/hooks/useNotificationSSE';
import { getTTSTourGuideValue } from '@src/utils/tourGuide';
import NewSidebar from './SidebarNew/index';
import Content from './Content';
import ServiceTerm from './ServiceTerm';
import {
  StyledWrapper,
  StyledMainPanel,
  StyledWrapperExpiringSoon,
} from './index.style';
import NewNavbar from './NewNavbar';
import AutoRenewDialog from './AutoRenewal/AutoRenewDialog';
import NewManageDevice from '../NewManageDevice';
import MigratedDubbingDialog from './MigratedDubbingDialog';
import ContentTransferPackage from './ContentTransferPackage';
import Survey from '../Survey';
import { languages } from './SidebarNew/UserInfo';
import RequireProvideEmailDialog from './RequireProvideEmailDialog';
import CancelReasonDialog from '../NewPayment/Dialog/CancelReason';
import HightLightWeek from '../HightLightWeek';
import Tasks from '../OnboardingTasks/Tasks';
import OnboardingTasks from '../OnboardingTasks';
import OnboardingDrawer from '../OnboardingTasks/OnboardingDrawer';
import PopupCompleteTask from '../OnboardingTasks/PopupCompleteTask';
import AutoRenewPriceAdjustmentPopup from './AutoRenewPriceAdjustment';

const Layout = ({ children, headerVoucher }) => {
  useRemoveInjectedIframe();
  useRedirectInvalidPaths();
  useOnboardingPopup();
  useNotificationSSE();
  const location = useLocation();
  const { ip } = useIpLocation();
  const { totalCredits } = useTotalCredits();
  const changeProductMode = useProductMode();
  const educatorsModeEnabled = useEducatorsModeEnabled();
  const [ipLocation, seIpLocation] = useState(null);
  const [isExceedDevices, setIsExceedDevices] = useState(false);
  const [showAutoRenewalBanner, setShowAutoRenewalBanner] = useState(false);
  const [userSurvey, setUserSurvey] = useState(false);
  const [banners, setBanners] = useState([]);
  const [hasAgreedToMigrateDubbing, setHasAgreedToMigrateDubbing] =
    useState(true);
  const [hasAgreeToMigrateToV3, setHasAgreeToMigrateToV3] = useState(true);
  const [isUserEligible, setIsUserEligible] = useState(undefined);
  const [
    showAutoRenewPriceAdjustmentPopup,
    setShowAutoRenewPriceAdjustmentPopup,
  ] = useState(false);
  const [rewardCredits, setRewardCredits] = useState(0);
  const [openRewardDialog, setOpenRewardDialog] = useState(false);
  const [openRequireProvideEmailDialog, setOpenRequireProvideEmailDialog] =
    useState(false);
  const [appliedReferralErrorMessage, setAppliedReferralErrorMessage] =
    useState(null);
  const { notificationDialog } = useSelector((state) => state.dialog);
  const { notificationDialogV2 } = useSelector((state) => state.dialog);
  const {
    showOnboardingPopup,
    showOnboardingTasks,
    showOnboardingPopupMobile,
    taskCompletedData,
  } = useSelector((state) => state.layout);
  const { accessToken, user } = useSelector((state) => state.auth);
  const userInfo = useSelector((state) => state.user || {});
  const { trialVoiceUsage: stateTrialVoiceUsage } = userInfo;
  const { synthesizingVoice } = useSelector(
    (state) => state.synthesisRequest || {},
  );
  const stateTrialVoiceUsageRef = useRef(stateTrialVoiceUsage);
  const { openSidebar } = useSelector((state) => state.layout);
  const { allowShowAutoRenewalBanner, seenAllBanner } = useSelector(
    (state) => state.banner,
  );
  const { openHighlightWeekDialog } = useSelector((state) => state.layout);
  const isUserCreatedToday = moment(user?.createdAt).isSame(moment(), 'day');
  const {
    isVisible,
    title,
    description,
    onUpgrade,
    onClose,
    img,
    classNameImg,
    maxWidth,
    showButtonUnderstand,
    showBlurBackground,
    showOnlyUnderstandButton,
    paywall: limitedFeaturePaywall,
  } = useSelector((state) => state.limitedFeaturesDialog);
  const { isVisible: isOnboardingPopupVisible, type: onboardingPopupType } =
    useSelector((state) => state.onboardingPopup);
  const { showPackageExpiringSoon, showNotifyLowCredits } = useSelector(
    (state) => state.layout,
  );
  const { isVisible: isCancelReasonDialogVisible } = useSelector(
    (state) => state.cancelReasonDialog,
  );
  const { multiBlock, product, dubbingRequestId, source } = useSelector(
    (state) => state.project,
  );
  const [openServiceTerm, setOpenServiceTerm] = useState(
    !user?.hasAgreedToTerms,
  );

  const multiBlockRef = useRef(multiBlock);
  const projectProductRef = useRef(product);
  const dubbingRequestIdRef = useRef(dubbingRequestId);
  const sourceRef = useRef(source);
  const synthesizingVoiceRef = useRef(synthesizingVoice);
  const {
    remainingCharacters,
    bonusCharacters = 0,
    preservationExpiryDate,
  } = user;
  const { remainingSeconds } = user?.dubbing || 0;

  const { usingPackage, subscriptionPurchase } = userInfo;
  const { ttsUser } = useUserInfo();
  const { isCustomerSupportView } = useCustomerSupportView();
  const { t } = useTranslation();
  const { language } = i18n;
  const ws = useRef(null);
  const remainingCharactersRef = useRef(remainingCharacters);
  const bonusCharactersRef = useRef(bonusCharacters);
  const remainingSecondsRef = useRef(remainingSeconds);
  const userRef = useRef(user);
  const ttsUserRef = useRef(ttsUser);
  const locationRef = useRef(location);
  const languageRef = useRef(language);
  const translationRef = useRef(t);
  const { keycloak, removeKcTokenCookie } = useCustomKeycloak();
  const { width: widthScreen } = useWindowDimensions();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDubbingRoute = useCheckDubbingRoute();
  const isEducatorsRoute = useCheckEducatorsRoute();
  const { packages } = useMappingPackage();

  const { search: searchReferral } = locationRef.current;
  const paramsReferral = new URLSearchParams(searchReferral);
  const referralCode = paramsReferral.get(REFERRAL_CODE_PARAM);
  const autoApplyReferral = paramsReferral.get(AUTO_APPLY_REFERRAL_PARAM);

  const showRedeem = paramsReferral.get(REDEEM_PARAM);

  const { getFeatureValue } = useFeatureFlags();

  // Lock endTime realignment after synthesis is part of the video
  // dubbing create-audio flow, gated by the same flag as ProjectDetail.
  const videoDubbingCreateAudioEnabled = getFeatureValue(
    FEATURE_KEYS.VIDEO_DUBBING_CREATE_AUDIO,
    { userId: user?.id, email: user?.email, phoneNumber: user?.phoneNumber },
  );
  const videoDubbingCreateAudioEnabledRef = useRef(
    videoDubbingCreateAudioEnabled,
  );
  useEffect(() => {
    videoDubbingCreateAudioEnabledRef.current = videoDubbingCreateAudioEnabled;
  }, [videoDubbingCreateAudioEnabled]);

  const ttsWalletFromServer = Boolean(
    getFeatureValue(FEATURE_KEYS.TTS_WALLET_FROM_SERVER, {
      userId: user?.id,
      email: user?.email,
      phoneNumber: user?.phoneNumber,
    }),
  );
  const ttsWalletFromServerRef = useRef(ttsWalletFromServer);
  useEffect(() => {
    ttsWalletFromServerRef.current = ttsWalletFromServer;
  }, [ttsWalletFromServer]);

  const usePushEventRegisterDirectlyToGTM = getFeatureValue(
    FEATURE_KEYS.PUSH_EVENT_TO_GTM_SERVER,
    { userId: user?.id, email: user?.email, ip },
  );

  const usePushEventBuyingDirectyToGTM = getFeatureValue(
    FEATURE_KEYS.PUSH_EVENT_TO_GTM_SERVER,
    { userId: user?.id, email: user?.email, ip },
  );

  const useSyncAffiliateMarketer = getFeatureValue(
    FEATURE_KEYS.SYNC_AFFILIATE_MARKETER,
  );

  const signupSurveyEnable = getFeatureValue(FEATURE_KEYS.SIGNUP_SURVEY, {
    userId: user?.id,
    email: user?.email,
    registeredAt: moment(user?.createdAt).valueOf(),
  });

  const emailRequiredEnabled = getFeatureValue(FEATURE_KEYS.EMAIL_REQUIRED, {
    userId: user?.id,
    phoneNumber: user?.phoneNumber,
  });

  const voiceTrialConfig = getFeatureValue(FEATURE_KEYS.TRIAL_VOICE_CONFIG, {
    userId: user?.id,
    email: user?.email,
    phoneNumber: user?.phoneNumber,
    packageCode: user.packageCode,
  });
  const enableVoiceTrial = Boolean(voiceTrialConfig);

  const dateNotifyNearExpiry = getFeatureValue(
    FEATURE_KEYS.NOTIFY_NEAR_EXPIRY,
    {
      userId: user?.id,
      email: user?.email,
      phoneNumber: user?.phoneNumber,
    },
  );

  const isLowCredits = checkLowCredits({
    totalCredits,
    packageCode: user?.packageCode,
  });
  const isPackageExpired = checkPackageExpired(user?.packageExpiryDate);
  const isNotifyLowCredits =
    isLowCredits &&
    !isPackageExpired &&
    location.pathname === ROUTES.MOBILE_TTS;
  const showNotifyLowCreditsBanner = isNotifyLowCredits && showNotifyLowCredits;

  const usingFreePackage = FREE_PACKAGE_CODES.includes(user?.packageCode);
  const isPackageExpiringSoon =
    isNumber(dateNotifyNearExpiry) &&
    !usingFreePackage &&
    location.pathname === ROUTES.MOBILE_TTS &&
    !!user?.packageExpiryDate &&
    hasPackageExpiringSoon(user?.packageExpiryDate, dateNotifyNearExpiry);
  const showPackageExpiringSoonBanner =
    isPackageExpiringSoon && showPackageExpiringSoon;

  const isFetchingSignUpSurvey = signupSurveyEnable && userSurvey === false;
  // Hashtag from url to display survey
  const canDisplaySurveyFromHashTag = location.hash === '#survey';

  const statusSurveyShowPopup = [
    STATUS_SURVEY.SKIPPED,
    STATUS_SURVEY.DONE,
    STATUS_SURVEY.DOING,
  ];
  const statusValidSurvey = statusSurveyShowPopup.includes(
    userSurvey?.signup?.status,
  );

  // If the user already completed or skipped the signup survey on mobile,
  // the onboarding must not be shown again regardless of the feature flag.
  const hasCompletedSignupMobile = [
    STATUS_SURVEY.DONE,
    STATUS_SURVEY.SKIPPED,
  ].includes(userSurvey?.signupMobile?.status);

  const isDisplaySignUpSurvey =
    (signupSurveyEnable && !statusValidSurvey && !hasCompletedSignupMobile) ||
    canDisplaySurveyFromHashTag;

  // Check with signup survey enable or not
  // to ensure that both user with signup survey enable
  // and user without signup survey enable have the same behavior
  const hasFinishedOnboarding = signupSurveyEnable
    ? (hasCompletedSignupMobile || statusValidSurvey) &&
      user?.hasAgreedToTerms &&
      seenAllBanner
    : user?.hasAgreedToTerms && seenAllBanner;

  const handleChangeBanners = (value) => setBanners(value);

  const handleOpenAutoRenewalPayment = () => {
    const isSeenAllBanner = allowShowAutoRenewalBanner;
    if (isSeenAllBanner) dispatch(actions.banner.addSeenAllBanner());
    setShowAutoRenewalBanner(false);
  };

  const userUseOneTimePackage = useMemo(() => {
    const packageVersion = usingPackage?.version || PACKAGE_STUDIO_VERSION.V1;
    return [
      PACKAGE_STUDIO_VERSION.V1,
      PACKAGE_STUDIO_VERSION.V2_1,
      PACKAGE_STUDIO_VERSION.V2,
    ].includes(packageVersion);
  }, [usingPackage]);

  const handleCloseAutoRenewDialog = (notShowAgain = false) => {
    localStorage.setItem(
      'AUTO_RENEWAL_BANNER',
      JSON.stringify({
        date: moment().format('DD/MM/YYYY'),
        notShowAgain,
      }),
    );
    setShowAutoRenewalBanner(false);
    dispatch(actions.banner.addSeenAllBanner());
  };

  const handleOpenSidebar = () =>
    dispatch(actions.layout.handleChangeOpenSidebar(true));

  const handleCloseSidebar = () =>
    dispatch(actions.layout.handleChangeOpenSidebar(false));

  const handleBackToTTSWhenConfirmedOrder = () => {
    const { pathname, search } = locationRef.current;
    if (pathname === ROUTES.PAYMENT && search.includes('package='))
      dispatch(actions.user.backToTTS());
    if (pathname === ROUTES.PAYMENT_DUBBING && search.includes('package='))
      dispatch(actions.user.backToDubbing());
  };

  const handleCloseQRPaymentWhenCanceledOrder = () => {
    const { pathname, search } = locationRef.current;
    if (
      (pathname === ROUTES.PAYMENT || pathname === ROUTES.PAYMENT_DUBBING) &&
      search.includes('package=')
    )
      dispatch(actions.user.closeQRPayment());
    if (
      pathname === ROUTES.PAYMENT_HISTORY ||
      pathname === ROUTES.PAYMENT_HISTORY_DUBBING
    )
      dispatch(actions.user.fetchPaymentHistory(true));
  };

  // Handle highlight week
  const cookieName = `highlights-of-week-${user?.id}`;
  const getCurrentWeekId = () => {
    const week = moment().isoWeek();
    const year = moment().isoWeekYear();
    return `${year}-W${week}`;
  };

  const daysUntilNextMonday = () => {
    const today = moment();
    const nextMonday = moment()
      .startOf('isoWeek')
      .add(1, 'week')
      .startOf('day');
    return nextMonday.diff(today, 'milliseconds');
  };

  useEffect(() => {
    if (!user?.id) return;
    const doneTourGuide = getTTSTourGuideValue(user?.id);
    const currentWeekId = getCurrentWeekId();

    if (
      shouldShowWeeklyHighlights({ userId: user?.id }) &&
      doneTourGuide &&
      !isUserCreatedToday &&
      !isCustomerSupportView
    ) {
      dispatch(actions.layout.openHighlightWeekDialog(true));
      setCookie({
        cname: cookieName,
        cvalue: currentWeekId,
        extime: daysUntilNextMonday(),
        domain: ENV === 'local' ? 'localhost' : VBEE_DOMAIN,
      });
    }
  }, [user?.id, isUserCreatedToday]);

  // Handle close highlight week
  const handleClose = () => {
    dispatch(actions.layout.openHighlightWeekDialog(false));
  };

  const fetchCountry = async () => {
    try {
      const data = await apis.country.getCountry();
      if (!data?.country) {
        seIpLocation(VIETNAM_LOCATION);
        return;
      }
      seIpLocation(data);
    } catch (error) {
      seIpLocation(VIETNAM_LOCATION);
    }
  };

  const showMigrateToV3Popup = useMemo(() => {
    const isExpiredPackage =
      !usingPackage.id ||
      (user.packageExpiryDate && moment().isAfter(user.packageExpiryDate));

    if (isExpiredPackage && user?.lockCharacters === 0) return false;
    if (user?.hasAgreeToMigrateToV3) return false;

    const shouldShowPopup =
      preservationExpiryDate &&
      moment().isBefore(preservationExpiryDate) &&
      usingPackage?.code &&
      Object.keys(MIGRATED_NAME_PACKAGE_CODES).includes(usingPackage?.code) &&
      !hasAgreeToMigrateToV3;

    return shouldShowPopup;
  }, [user, usingPackage, hasAgreeToMigrateToV3, preservationExpiryDate]);

  // Popups the user must deal with — a device limit, a consent, a missing email
  // — outrank the survey, so it waits rather than stacking on top of them. The
  // onboarding tasks are not among them: they now come after the survey, so
  // waiting for them would leave each side waiting on the other.
  const hasBlockingPopup =
    isFetchingSignUpSurvey ||
    isDisplaySignUpSurvey ||
    openServiceTerm ||
    isExceedDevices ||
    showMigrateToV3Popup ||
    !hasAgreedToMigrateDubbing ||
    showAutoRenewalBanner ||
    Boolean(emailRequiredEnabled && openRequireProvideEmailDialog);

  useEducatorsSurveyPopup({
    userSurvey,
    hasBlockingPopup,
  });

  // While an Educators popup is up, the layout's own dismissible popups wait.
  const {
    isBlocking: isEducatorsPopupBlocking,
    isWelcomeVisible: isEducatorsWelcomeVisible,
    isWelcomeHolding: isEducatorsWelcomeHolding,
  } = useEducatorsPopupChain({ userSurvey });

  // The whole Educators queue — welcome board, then survey — runs ahead of the
  // onboarding tasks and of everything else the layout would put up. Only the
  // rendering waits: each popup keeps the state that made it due, so it
  // reappears rather than being lost. False throughout while the mode is off,
  // which leaves every popup below behaving exactly as it did before.
  const isEducatorsQueueRunning =
    isEducatorsPopupBlocking || isEducatorsWelcomeHolding;

  // The welcome board rides on the shared onboarding popup, so it cannot be one
  // of the popups it holds back. While it is up only the terms outrank it — and
  // a phone, where the board describes a home page the visitor cannot reach. The
  // Educators home already declines to open it there, so this catches the window
  // left over: opened on a desktop, then the window pulled narrow.
  const isOnboardingPopupHeldBack = isEducatorsWelcomeVisible
    ? isMobile || openServiceTerm
    : isEducatorsQueueRunning;

  // Behind the queue, the onboarding tasks are not merely held for a while —
  // they are put off to the next visit entirely.
  usePostponedOnboardingTasks({ isEducatorsQueueRunning });

  const handleCheckOpenRequireProvideEmailDialog = () => {
    if (!emailRequiredEnabled) return;

    if (!checkUserHasProvidedEmail(user)) {
      // When user register, the requireEmailAt is not set
      // So we don't open the dialog
      if (!user?.requireEmailAt) return;

      const requiredEmailExpiredAt = moment(user.requireEmailAt);

      const remainingTime = moment(requiredEmailExpiredAt)
        .startOf('day')
        .diff(moment().startOf('day'), 'days');

      const isRequiredEmailExpired = remainingTime <= 0;

      if (isRequiredEmailExpired) {
        setOpenRequireProvideEmailDialog(true);
        return;
      }

      if (
        remainingTime > 0 &&
        remainingTime <= emailRequiredEnabled?.optionalWindowTime
      ) {
        if (getCookie(`${HAS_OPENED_REQUIRE_PROVIDE_EMAIL_DIALOG}-${user?.id}`))
          return;

        const current = moment();
        const endOfDay = current.clone().endOf('day');
        const diff = endOfDay.diff(current);
        const duration = moment.duration(diff);

        setCookie({
          cname: `${HAS_OPENED_REQUIRE_PROVIDE_EMAIL_DIALOG}-${user?.id}`,
          cvalue: true,
          extime: duration.asMilliseconds(),
          domain: VBEE_DOMAIN,
        });

        setOpenRequireProvideEmailDialog(true);
      }
    }
  };

  const handleOpenRequiredEmailDialogAt = () => {
    if (!hasFinishedOnboarding) return;

    if (!autoApplyReferral) {
      handleCheckOpenRequireProvideEmailDialog();
      return;
    }

    if (isUserEligible === undefined) return;

    if (appliedReferralErrorMessage) {
      if (!userInfo.isOpeningReferralErrorNotiPopup) {
        handleCheckOpenRequireProvideEmailDialog();
      }
      return;
    }

    if (!isUserEligible) {
      if (!userInfo.isOpeningReferralErrorNotiPopup) {
        handleCheckOpenRequireProvideEmailDialog();
      }
      return;
    }

    if (isUserEligible) {
      if (!openRewardDialog) {
        handleCheckOpenRequireProvideEmailDialog();
      }
    }
  };

  const fetchSubscriptionPurchase = async (
    purchaseId,
    purchaseStatus,
    isRegisterAutoRenew,
  ) => {
    const data = await apis.subscription.getSubscriptionInfo(purchaseId);
    const { status, result = {} } = data || {};
    if (status === 1) {
      dispatch(actions.user.updateSubscriptionPurchase(result));

      const { orderInfo } = result;
      if (!orderInfo) return;
      const { price, usdPrice, packageExpiryDate, packageCode } = orderInfo;
      const packageName = getPackageName(null, packageCode, language, t, true);

      const hasAutoRenewNotification = getCookie(
        `auto-renewal-notification-${purchaseId}`,
      );
      if (
        !hasAutoRenewNotification &&
        purchaseId &&
        purchaseStatus === SUBSCRIPTION_PURCHASE_STATUS.ACTIVE
      ) {
        if (!isRegisterAutoRenew)
          dispatch(
            actions.banner.updateDisplayBanner(
              BANNER_TYPE.JOIN_ZALO_GROUP,
              true,
              {
                packageName,
                isAutoRenewalPackage: true,
                packagePrice: price,
                packageUsdPrice: usdPrice,
                packageExpiryDate,
              },
            ),
          );

        if (isRegisterAutoRenew)
          dispatch(
            actions.noti.push({
              severity: 'success',
              message: 'registerAutoRenewSuccess',
            }),
          );

        setCookie({
          cname: `auto-renewal-notification-${purchaseId}`,
          cvalue: true,
          domain: VBEE_DOMAIN,
          extime: 1000 * 60 * 60 * 24 * 14,
        });
      }
    }
  };

  const fetchBannerVoucher = async () => {
    const response = await apis.vouchers.getBannerVouchersFinal(accessToken);

    if (response?.status !== 1) return;
    const bannerVouchers = response?.result?.vouchers || [];
    if (bannerVouchers?.length) {
      dispatch(actions.voucher.updateBannerVoucher(bannerVouchers));
    }
  };

  // const pushDataDeviceToMoe = async () => {
  //   const { result: apiResult = {} } = await apis.devices.getDevices({});
  //   const onlineDevices =
  //     apiResult?.devices?.filter(
  //       (device) => device.status === DEVICE_STATUS.ONLINE,
  //     ).length || 0;
  //   const restrictedDevices =
  //     apiResult?.devices?.filter(
  //       (device) => device.status === DEVICE_STATUS.RESTRICTED,
  //     ).length || 0;

  //   window.dataLayer.push({
  //     event: EVENT_TYPE.DEVICE_MANAGER,
  //     userId: user?.id,
  //     maxDevices: user.maxDevices || userInfo?.usingPackage?.device,
  //     onlineDevices,
  //     restrictedDevices,
  //     time: moment().format('DD/MM/YYYY - HH:mm'),
  //   });
  // };

  const pushNewUserToGTM = async () => {
    if (usePushEventRegisterDirectlyToGTM) return;
    const { createdAt, email, id, affiliateMarketerId, pushedToGtm } =
      user || {};
    if (pushedToGtm) return;

    // Only push new user to GTM if user created today
    const checkNewUser = moment().diff(moment(createdAt), 'days') === 0;
    if (!checkNewUser) return;

    window.dataLayer.push({
      event: EVENT_TYPE.SIGN_UP_SUCCESS,
      email,
      userId: id,
      affiliateMarketerId,
    });

    apis.user.confirmPushUserToGTM();
  };

  const handleIdentifyMoEngageUser = () => {
    identifyUser(user, { locale: language });
  };

  const checkUserDeviceV2 = async () => {
    try {
      const data = await apis.devices.checkUserDevice();
      const { check, fingerprint } = data;
      dispatch(
        actions.deviceV2.addDeviceResponse({
          fingerprint,
          status: check,
        }),
      );
      localStorage.setItem('fingerprint-v2', fingerprint);
      if (
        check === DEVICE_STATUS.OFFLINE ||
        check === DEVICE_STATUS.RESTRICTED
      ) {
        setIsExceedDevices(true);
        // pushDataDeviceToMoe();
      } else setIsExceedDevices(false);
    } catch (error) {
      setIsExceedDevices(false);
    }
  };

  const trackingEvents = async () => {
    if (usePushEventBuyingDirectyToGTM) return;
    const { result: apiResult } = await apis.orders.getOrders({
      userId: userRef.current.id,
      status: ORDER_STATUS.PAID,
      sort: 'createdAt_desc',
      limit: 1,
    });
    if (apiResult?.orders?.length === 0) return;
    const order = apiResult?.orders[0] || {};
    const totalPaidOrders = apiResult?.total || 0;
    if (order.pushDataToMoe) return;

    // Send data to GTM
    window.dataLayer.push({
      event: EVENT_TYPE.BUY_PACKAGE,
      customerName: `${user.lastName} ${user.firstName}`,
      email: user.email,
      phoneNumber: user.phoneNumber || order?.user?.phoneNumber,
      orderId: order.id,
      package: order.package?.code,
      type: order.type,
      packageExpiryDate: order.packageExpiryDate,
      packagePrice: order.packagePrice || order?.package?.price,
      paidCharacters:
        order?.customPackage?.maxCharacters || order?.package?.maxCharacters,
      paymentMethodSource:
        order?.paymentMethod?.source || order?.paymentMethodSource,
      confirmedFrom: order?.confirmedFrom,
      confirmedAt: order?.confirmedAt,
      packageType: order?.type,
      totalPaidOrders,
      affiliateMarketerId: order?.affiliateMarketerId,
      userId: user.id,
    });

    apis.orders.updateMoeStatus(order.id);
  };

  const sendOrderToGTM = async ({
    orderId,
    phoneNumber,
    packageCode,
    type,
    packageExpiryDate,
    paidCharacters,
    paymentMethodSource,
    confirmedFrom,
    confirmedAt,
    packageType,
    userId,
  }) => {
    if (usePushEventBuyingDirectyToGTM) return;
    window.dataLayer.push({
      event: EVENT_TYPE.BUY_PACKAGE,
      customerName: `${user.lastName} ${user.firstName}`,
      email: user.email,
      phoneNumber: user.phoneNumber || phoneNumber,
      orderId,
      packageCode,
      type,
      packageExpiryDate,
      paidCharacters,
      paymentMethodSource,
      confirmedFrom,
      confirmedAt,
      packageType,
      userId,
    });

    apis.orders.updateMoeStatus(orderId);
  };

  const handleUpdateAffiliateMarketer = async () => {
    const affiliateCode = getCookie('affiliateCode');
    const affiliateTime = getCookie('affiliateTime');
    if (!affiliateCode || !affiliateTime) return;

    await apis.affiliateMarketer.updateAffiliateMarketer({
      affiliateCode,
      affiliateTime,
      accessToken,
    });

    // Remove cookies after update
    removeCookie('affiliateCode');
    removeCookie('affiliateTime');
  };

  const checkUserAffiliateMatch = async () => {
    const affiliateCode = getCookie('affiliateCode');
    const affiliateTime = getCookie('affiliateTime');
    if (!affiliateCode || !affiliateTime) return;

    const res = await apis.affiliateMarketer.checkUserAffiliateMatch({
      affiliateCode,
      affiliateTime,
      accessToken,
    });

    // Remove cookies when affiliate match
    if (res?.result?.isMatched) {
      removeCookie('affiliateCode');
      removeCookie('affiliateTime');
    }
  };

  const handleUpdateAdsProvider = async () => {
    const adsProvider = getCookie('adsProvider');
    const adsProviderTime = getCookie('adsProviderTime');
    if (!adsProvider || !adsProviderTime) return;

    await apis.adsProvider.updateAdsProvider({
      adsProvider,
      adsProviderTime,
    });

    // Remove cookies after update
    removeCookie('adsProvider');
    removeCookie('adsProviderTime');
  };

  const handleShowNotiWhenCancelSubscription = async () => {
    const { search } = locationRef.current;
    const params = new URLSearchParams(search);
    const purchaseId = params.get('purchaseId');
    const status = params.get('status');

    if (purchaseId && status.includes(ORDER_STATUS.CANCEL)) {
      // Delay 2s for waiting display ui
      await delay(2000);

      dispatch(
        actions.noti.push({
          severity: 'error',
          message: 'transactionFailed',
        }),
      );

      // Remove query params after display notification
      history.replace({
        pathname: location.pathname,
        search: '',
      });
    }
  };

  // Answering as a teacher puts the account straight into Educators mode. Only
  // the survey a new account is greeted with counts — reopened later from an
  // onboarding task, it must leave the mode the user has since settled on alone.
  const handleUpdateUserSurvey = (status, answers) => {
    if (canDisplaySurveyFromHashTag) {
      history.replace({
        pathname: location.pathname,
        hash: '',
      });
      dispatch(actions.layout.setShowCompleteTaskSurveyDialog(false));
    } else if (
      educatorsModeEnabled &&
      status === STATUS_SURVEY.DONE &&
      hasEducatorsSignupAnswer(answers)
    ) {
      changeProductMode(PRODUCT_MODE.EDUCATORS);
      history.push(ROUTES.EDUCATORS_HOME);
    }

    setUserSurvey({
      ...userSurvey,
      signup: { ...userSurvey?.signup, status },
    });
  };

  const handleChangeLanguage = (lng) => {
    i18n.changeLanguage(lng.value);
  };

  // Video dubbing (US-09.1): once a block's audio arrives, realign its endTime
  // to the audio length (shrink to
  // fit a shorter audio). Local update keeps the timeline + per-block playback
  // duration correct; autoSaveTrigger persists it. Video source only.
  const adjustDubbingBlockEndTimeToAudio = async (blockId, audioLink) => {
    if (
      !videoDubbingCreateAudioEnabledRef.current ||
      !isVideoSource(sourceRef.current) ||
      !audioLink
    )
      return;
    const { blocks } = multiBlockRef.current || {};
    const storeBlock = blocks?.[blockId];
    if (!storeBlock) return;
    const audioDuration = await loadAudioDurationFromUrl(audioLink);
    const newEndTime = getAudioAdjustedBlockEndTime({
      startTime: storeBlock.startTime,
      endTime: storeBlock.endTime,
      audioDuration,
    });
    if (!newEndTime) return;
    dispatch(
      actions.project.updateBlockSynthesisInfo(blockId, {
        endTime: newEndTime,
      }),
    );
    dispatch(actions.project.autoSaveTrigger());
  };

  const handleSynthesisBlockResponse = ({ requestId, status, audioLink }) => {
    // Handle synthesis response for dubbing project
    if (
      projectProductRef.current === PROJECT_PRODUCT.DUBBING &&
      dubbingRequestIdRef.current === requestId
    ) {
      dispatch(actions.project.setAudioLinkSrt(audioLink));
      dispatch(actions.project.setStatus(status));
      dispatch(actions.project.setIsProjectSynthesizing(false));
      dispatch(actions.project.setTranslationPendingSynthesis(false));
      if (status === CONVERTING_STATUS.FAILURE) {
        dispatch(
          actions.noti.push({
            severity: 'error',
            message: 'synthesisFailure',
          }),
        );
      }
      return;
    }

    // Handle synthesis response for TTS project
    const { blocks, blockIds } = multiBlockRef.current;
    const synthesisBlockId = blockIds.find(
      (blockId) => blocks[blockId].requestId === requestId,
    );

    if (synthesisBlockId) {
      dispatch(
        actions.project.updateBlockSynthesisInfo(synthesisBlockId, {
          audioLink,
          status,
          showSuccessIcon: Boolean(audioLink),
          audioExpiredAt: null, // Delete the old audioExpiredAt to remove the audio expired icon
        }),
      );
      dispatch(
        actions.project.updateBlockStatus({
          blockId: synthesisBlockId,
          blockStatus:
            status === CONVERTING_STATUS.SUCCESS
              ? BLOCK_STATUS.AUDIO_AVAILABLE
              : BLOCK_STATUS.ERROR,
        }),
      );
      if (status === CONVERTING_STATUS.SUCCESS && audioLink) {
        adjustDubbingBlockEndTimeToAudio(synthesisBlockId, audioLink);
      }
    }
  };

  const fetchReferralConfig = async () => {
    const response = await apis.referral.getReferralConfig();
    if (response?.status) {
      const referralConfig = response.result;
      dispatch(actions.referralConfig.loadReferralConfig(referralConfig));
    }
  };

  const handleCheckUserEligibility = async () => {
    const result = await apis.referral.checkUserEligibility();
    return Boolean(result?.status);
  };

  const handleApplyReferral = async () => {
    const result = await apis.referral.applyReferral(referralCode);
    if (result?.status) {
      const refereeReward = result?.result?.refereeRewards?.find(
        (reward) => reward.type === 'character',
      );
      setRewardCredits(refereeReward?.details?.characters || 0);
      dispatch(actions.auth.updateReferrerId(result?.result?.referrerId));
    } else {
      setAppliedReferralErrorMessage(t('invalidReferralCode'));
    }
  };

  const handleReferralCodeFromURL = async () => {
    if (referralCode) {
      const result = await apis.referral.checkUserEligibility();
      if (!result?.status) {
        dispatch(actions.user.openReferralErrorNotiPopup());
        return;
      }
      dispatch(actions.user.updateIsOpeningRedeemReferralDialog(true));
    }
  };

  const handleShowRedeem = () => {
    if (showRedeem === 'true') {
      dispatch(actions.user.updateIsOpeningRedeemReferralDialog(true));
    }
  };

  useEffect(() => {
    if (!hasFinishedOnboarding) return;
    handleShowRedeem();
  }, [showRedeem, hasFinishedOnboarding]);

  useEffect(() => {
    const currentLanguageValue = getCookie('lng');
    const currentLanguage = languages.find(
      (lng) => lng.value === currentLanguageValue,
    );

    if (ipLocation) {
      const { country: countryCode } = ipLocation;
      localStorage.setItem('country', COUNTRY[countryCode] || COUNTRY.EN);
    }

    if (currentLanguage) {
      handleChangeLanguage(currentLanguage);
      return;
    }

    const countryLanguageValue = localStorage.getItem('country');
    const countryLanguage = languages.find(
      (lng) => lng.country === countryLanguageValue,
    );
    if (countryLanguage) {
      handleChangeLanguage(countryLanguage);
      return;
    }

    handleChangeLanguage(languages[0]);
  }, [ipLocation]);

  useEffect(() => {
    const getUserSurvey = async () => {
      const response = await apis.survey.getSurveyUser();
      setUserSurvey(response?.result);
    };
    const getPackages = async () => {
      const response = await apis.packages.getPackages({
        active: true,
        purchasable: true,
      });
      if (response?.status) {
        dispatch(actions.package.addPackage(response?.result?.packages || []));
      }
    };
    getPackages();
    getUserSurvey();
  }, []);

  // Default open sidebar
  // Close sidebar when screen width < 600px
  useEffect(() => {
    if (widthScreen < 600) {
      handleCloseSidebar();
    }
  }, [widthScreen]);

  const isDetailProjectPage = useCheckProjectRoute();
  useEffect(() => {
    if (isDetailProjectPage) {
      handleCloseSidebar();
    } else {
      handleOpenSidebar();
    }
  }, [isDetailProjectPage]);

  useEffect(() => {
    ReactGA.set({ userId: user.id });
  }, [keycloak.authenticated]);

  useEffect(() => {
    handleOpenAutoRenewalPayment();
  }, [usingPackage, allowShowAutoRenewalBanner, subscriptionPurchase]);

  useEffect(() => {
    if (useSyncAffiliateMarketer) checkUserAffiliateMatch();
    else handleUpdateAffiliateMarketer();

    handleUpdateAdsProvider();
  }, []);

  useEffect(() => {
    pushNewUserToGTM();
    handleIdentifyMoEngageUser();
  }, [user]);

  useEffect(() => {
    remainingCharactersRef.current = remainingCharacters;
  }, [remainingCharacters]);

  useEffect(() => {
    bonusCharactersRef.current = bonusCharacters;
  }, [bonusCharacters]);

  useEffect(() => {
    remainingSecondsRef.current = remainingSeconds;
  }, [remainingSeconds]);

  useEffect(() => {
    userRef.current = user;
  }, [user]);

  useEffect(() => {
    ttsUserRef.current = ttsUser;
  }, [ttsUser]);

  useEffect(() => {
    locationRef.current = location;
    handleShowNotiWhenCancelSubscription();
  }, [location]);

  useEffect(() => {
    languageRef.current = language;
  }, [language]);

  useEffect(() => {
    multiBlockRef.current = multiBlock;
  }, [multiBlock]);

  useEffect(() => {
    projectProductRef.current = product;
  }, [product]);

  useEffect(() => {
    stateTrialVoiceUsageRef.current = stateTrialVoiceUsage;
  }, [stateTrialVoiceUsage]);

  useEffect(() => {
    synthesizingVoiceRef.current = synthesizingVoice;
  }, [synthesizingVoice]);

  useEffect(() => {
    dubbingRequestIdRef.current = dubbingRequestId;
  }, [dubbingRequestId]);

  useEffect(() => {
    sourceRef.current = source;
  }, [source]);

  useEffect(() => {
    translationRef.current = t;
  }, [t]);

  useEffect(() => {
    apis.account.updateOnlineStatus();

    const updateOnlineStatusInterval = setInterval(() => {
      apis.account.updateOnlineStatus();
    }, UPDATE_ONLINE_STATUS_INTERVAL);

    return () => clearInterval(updateOnlineStatusInterval);
  }, []);

  useEffect(() => {
    checkUserDeviceV2();
  }, [location?.pathname]);

  useEffect(() => {
    fetchSubscriptionPurchase();
    fetchBannerVoucher();
    dispatch(actions.user.getTtsUser());
    dispatch(actions.user.getTrialVoiceUsage());
  }, []);

  useEffect(() => {
    const createNotificationWSConnection = async () => {
      ws.current = new WebSocket(NOTIFICATION_URL);
      let pingInterval;
      ws.current.onopen = () => {
        ws.current.send(JSON.stringify({ type: WS_TYPE.INIT, accessToken }));
        pingInterval = setInterval(() => {
          ws.current.send(JSON.stringify({ type: WS_TYPE.PING }));
        }, PING_INTERVAL);
      };

      ws.current.onmessage = (res) => {
        const responseData = camelcaseKeys(JSON.parse(res.data), {
          deep: true,
        });
        const { type, result } = responseData;

        const handleSynthesis = () => {
          const {
            requestId,
            audioLink,
            status,
            characters,
            seconds,
            progress,
            processingAt,
            endedAt,
            blockedCredits,
            sentencesCreditsInfo,
            projectId,
          } = result;

          switch (status) {
            case SYNTHESIS_STATUS.CREATED: {
              if (seconds) {
                let currentSeconds = remainingSecondsRef.current;
                currentSeconds -= seconds;
                dispatch(
                  actions.auth.updateUserInfo({
                    ...userRef.current,
                    dubbing: {
                      ...userRef.current.dubbing,
                      remainingSeconds: currentSeconds,
                    },
                  }),
                );
              } else if (!ttsWalletFromServerRef.current) {
                const updatedUser = userRef.current;
                const updatedTtsUser = ttsUserRef.current;

                // order of subtract credit: topup -> cycle -> onetime (bonusCharacters -> remainingChracters)
                const userUpdatedCredits = sentencesCreditsInfo
                  ? getUserUpdateCreditsProcessWallet({
                      sentencesCreditsInfo,
                      currWallets: {
                        onetimeCredits:
                          updatedUser.remainingCharacters +
                          updatedUser.bonusCharacters,
                        cycleCredits:
                          updatedTtsUser?.studio?.cycle?.remainingCredits || 0,
                        topUpCredits:
                          updatedTtsUser?.studio?.topUp?.remainingCredits || 0,
                        customCredits:
                          updatedTtsUser?.studio?.custom?.remainingCredits || 0,
                      },
                      isFreeUser: checkFreePackage(
                        userRef.current?.packageCode,
                      ),
                    })
                  : getUserUpdateCredits({
                      ttsUser: updatedTtsUser,
                      user: updatedUser,
                      credits: characters,
                      blockedCredits,
                    });

                updatedUser.remainingCharacters =
                  userUpdatedCredits.remainingCharacters || 0;
                updatedUser.bonusCharacters =
                  userUpdatedCredits.bonusCharacters || 0;

                dispatch(
                  actions.auth.updateUserInfo({
                    ...updatedUser,
                  }),
                );

                dispatch(
                  actions.user.getTtsUserSuccess({
                    ...updatedTtsUser,
                    studio: {
                      ...(updatedTtsUser?.studio || {}),
                      cycle: {
                        ...(updatedTtsUser?.studio?.cycle || {}),
                        remainingCredits:
                          userUpdatedCredits['studio.cycle.remainingCredits'] ||
                          0,
                      },
                      topUp: {
                        ...(updatedTtsUser?.studio?.topUp || {}),
                        remainingCredits:
                          userUpdatedCredits['studio.topUp.remainingCredits'] ||
                          0,
                      },
                      custom: {
                        ...(updatedTtsUser?.studio?.custom || {}),
                        remainingCredits:
                          userUpdatedCredits[
                            'studio.custom.remainingCredits'
                          ] || 0,
                      },
                    },
                  }),
                );
              }

              break;
            }
            case SYNTHESIS_STATUS.SUCCESS: {
              if (!processingAt || !endedAt) break; // To avoid update synthesisRequest when backend send message with status SUCCESS but not send processingAt and endedAt
              trackConvertSuccess({
                requestId,
                characters,
                seconds,
                projectId,
              });
              if (projectId) {
                handleSynthesisBlockResponse({ requestId, audioLink, status });
              } else {
                dispatch(
                  actions.request.addSynthesisResponse({
                    requestId,
                    audioLink,
                    status,
                    processingAt,
                    endedAt,
                  }),
                );
              }

              break;
            }

            case SYNTHESIS_STATUS.FAILURE: {
              const paid = result.paidCharacters || 0;
              const bonus = result.bonusCharacters || 0;
              if (projectId) {
                handleSynthesisBlockResponse({
                  requestId,
                  audioLink: null,
                  status,
                });
              } else {
                dispatch(
                  actions.request.addSynthesisResponse({
                    requestId,
                    audioLink,
                    status,
                  }),
                );
              }
              if (!ttsWalletFromServerRef.current) {
                dispatch(
                  actions.auth.updateUserInfo({
                    ...userRef.current,
                    remainingCharacters: remainingCharactersRef.current + paid,
                    bonusCharacters: bonusCharactersRef.current + bonus,
                  }),
                );
              }

              // Rollback trial usage if applicable
              if (
                enableVoiceTrial &&
                synthesizingVoiceRef.current?.[requestId]
              ) {
                const candidates = synthesizingVoiceRef.current?.[requestId];
                const rolledBackUsage = rollbackTrialUsage({
                  currentUsage: stateTrialVoiceUsageRef.current,
                  voices: candidates,
                  config: voiceTrialConfig,
                });

                if (rolledBackUsage) {
                  dispatch(actions.user.updateTrialVoiceUsage(rolledBackUsage));
                }

                // Remove mapping after rollback
                dispatch(
                  actions.synthesisRequest.clearSynthesizingVoice(requestId),
                );
              }
              break;
            }
            case SYNTHESIS_STATUS.IN_PROGRESS: {
              const updateData = { requestId, audioLink, status, progress };
              if (processingAt) updateData.processingAt = processingAt;
              dispatch(actions.request.addSynthesisResponse(updateData));
              break;
            }
            default:
              break;
          }

          // CREATED only settles credits. The editor has no outcome to show
          // yet, and the request list ignores this status for the same reason.
          if (status === SYNTHESIS_STATUS.CREATED) return;

          // The progress animation is driven from these two timestamps, so a
          // SUCCESS without them would render a nonsense percentage. Wait for
          // a message or a poll that carries them.
          if (
            status === SYNTHESIS_STATUS.SUCCESS &&
            (!processingAt || !endedAt)
          )
            return;

          // The reducer owns the id match, so a message for a request the
          // editor is not holding is simply dropped there.
          dispatch(
            actions.synthesisRequest.applySynthesisOutcome({
              requestId,
              status,
              progress,
              audioLink,
              processingAt,
              endedAt,
            }),
          );
        };

        const updateUserInfo = async (isDelay) => {
          // Delay time for wait update database reset bonus characters
          if (isDelay) await delay(TIME_DELAY_CALL_API_GET_USER_INFO);
          dispatch(actions.user.getTtsUser());
          const userRes = await apis.account.getMe();
          dispatch(actions.auth.updateUserInfo(userRes.result));
        };

        const handleOrder = async () => {
          const {
            type: packageType,
            packageCode,
            renewalType,
            packagePrice,
            packageUsdPrice,
            packageExpiryDate,
            status,
            remainingCharacters: remaining,
            bonusCharacters: bonus,
            lockCharacters,
            remainingSeconds: resultSeconds,
            lockSeconds,
            studio,
            rewardCodes,
          } = result;
          const isAutoRenewalPackage = checkAutoRenewalPackage({ renewalType });
          switch (status) {
            case WS_ORDER_STATUS.PAID: {
              if (packageType === PACKAGE_TYPE.API) {
                handleBackToTTSWhenConfirmedOrder();
                break;
              }

              const isFreePackage = FREE_PACKAGE_CODES.includes(
                packageCode || '',
              );
              if (packageCode) {
                if (!isFreePackage) {
                  const packageName = getPackageName(
                    null,
                    packageCode,
                    languageRef.current,
                    translationRef.current,
                    true,
                  );
                  dispatch(
                    actions.banner.updateDisplayBanner(
                      BANNER_TYPE.JOIN_ZALO_GROUP,
                      true,
                      {
                        isTopUpPackage: isTopUpPackageCode(packageCode),
                        packageType,
                        packageName,
                        isAutoRenewalPackage,
                        packagePrice,
                        packageUsdPrice,
                        packageExpiryDate,
                        rewardCodes,
                      },
                    ),
                  );
                }

                const updatedUserInfo = { ...userRef.current };
                if (packageType === PACKAGE_TYPE.DUBBING) {
                  updatedUserInfo.dubbing = {
                    ...userRef.current.dubbing,
                    packageCode,
                    packageExpiryDate,
                  };
                  dispatch(
                    actions.user.getLatestDubbingOrder(userRef.current.id),
                  );
                } else {
                  if (!isTopUpPackageCode(packageCode)) {
                    updatedUserInfo.packageCode = packageCode;
                  }

                  updatedUserInfo.packageExpiryDate = packageExpiryDate;
                  dispatch(actions.user.getLatestOrder(userRef.current.id));
                }
                dispatch(actions.auth.updateUserInfo(updatedUserInfo));
                dispatch(actions.user.getUsingPackage(userRef.current.id));
                dispatch(actions.order.updateVoucher(null));
                dispatch(actions.user.getTtsUser());
                handleBackToTTSWhenConfirmedOrder();

                trackingEvents();
              }

              // TODO: Delete this because we remove dubbing package
              if (resultSeconds || lockSeconds) {
                dispatch(
                  actions.auth.updateUserInfo({
                    ...userRef.current,
                    dubbing: {
                      ...userRef.current.dubbing,
                      remainingSeconds: resultSeconds,
                      lockSeconds,
                    },
                  }),
                );
              }

              if (remaining || bonus || lockCharacters) {
                dispatch(
                  actions.auth.updateUserInfo({
                    ...userRef.current,
                    remainingCharacters: remaining,
                    // Do this because if user receive bonus characters from referral, we need to add to bonusCharactersRef.current
                    bonusCharacters: bonusCharactersRef.current + bonus,
                    lockCharacters,
                  }),
                );
              }

              if (
                studio &&
                (studio?.cycle?.remainingCredits ||
                  studio?.topUp?.remainingCredits)
              ) {
                dispatch(
                  actions.auth.updateUserInfo({
                    ...userRef.current,
                    bonusCharacters: 0,
                  }),
                );
                const updatedCreditTtsUser = { ...ttsUserRef.current };
                dispatch(
                  actions.user.getTtsUserSuccess({
                    ...updatedCreditTtsUser,
                    studio: {
                      ...(updatedCreditTtsUser?.studio || {}),
                      cycle: {
                        ...(updatedCreditTtsUser?.studio?.cycle || {}),
                        remainingCredits: studio?.cycle?.remainingCredits,
                      },
                      topUp: {
                        ...(updatedCreditTtsUser?.topUp || {}),
                        remainingCredits: studio?.topUp?.remainingCredits,
                      },
                    },
                  }),
                );
              }

              if (
                studio &&
                studio?.cycle?.nextResetAt &&
                studio?.cycle?.period
              ) {
                const updatedTtsUser = { ...ttsUserRef.current };
                dispatch(
                  actions.user.getTtsUserSuccess({
                    ...updatedTtsUser,
                    studio: {
                      ...(updatedTtsUser?.studio || {}),
                      cycle: {
                        ...(updatedTtsUser?.studio?.cycle || {}),
                        nextResetAt: studio.cycle.nextResetAt,
                        period: studio.cycle.period,
                      },
                    },
                  }),
                );
              }

              await updateUserInfo(isFreePackage);
              break;
            }

            case WS_ORDER_STATUS.CANCEL: {
              if (packageType === PACKAGE_TYPE.DUBBING) {
                dispatch(
                  actions.user.getLatestDubbingOrder(userRef.current.id),
                );
                if (isDubbingRoute) {
                  dispatch(
                    actions.noti.push({
                      severity: 'success',
                      message: 'notiCanceledOrder',
                    }),
                  );
                  handleCloseQRPaymentWhenCanceledOrder();
                }
              } else {
                dispatch(actions.user.getLatestOrder(userRef.current.id));
                if (!isDubbingRoute) {
                  dispatch(
                    actions.noti.push({
                      severity: 'success',
                      message: 'notiCanceledOrder',
                    }),
                  );
                  handleCloseQRPaymentWhenCanceledOrder();
                }
              }

              dispatch(actions.order.updateVoucher(null));
              dispatch(actions.user.lockCycleTopUpCredits(false));
              break;
            }

            default:
              break;
          }
        };

        const handleLogout = (fingerprintDevice) => {
          const fingerprint = localStorage.getItem('fingerprint-v2') || '';

          const isMatchingDevice = fingerprintDevice === fingerprint;

          if (isMatchingDevice) {
            removeKcTokenCookie();
            clearMoengageIdentity();
            keycloak.logout({ redirectUri: LANDING_PAGE_URL, fingerprint });
          }
        };

        const handleAffiliateNotification = () => {
          const { notificationType } = result;
          switch (notificationType) {
            case AFFILIATE_NOTIFICATION_TYPE.CREATE_AFFILIATE_TRANSACTION_FAILURE: {
              dispatch(
                actions.noti.push({
                  severity: 'error',
                  message: 'createAffiliateTransactionFailure',
                }),
              );
              break;
            }

            // case AFFILIATE_NOTIFICATION_TYPE.CREATE_AFFILIATE_TRANSACTION_SUCCESS: {
            //   dispatch(
            //     actions.noti.push({
            //       severity: 'success',
            //       message: 'createAffiliateTransactionSuccess',
            //     }),
            //   );
            //   break;
            // }

            case AFFILIATE_NOTIFICATION_TYPE.AFFILIATE_TRANSACTION_APPROVED: {
              dispatch(
                actions.noti.push({
                  severity: 'success',
                  message: 'paymentRequestApproved',
                }),
              );
              break;
            }

            case AFFILIATE_NOTIFICATION_TYPE.AFFILIATE_TRANSACTION_REJECTED: {
              dispatch(
                actions.noti.push({
                  severity: 'error',
                  message: 'paymentRequestRejected',
                }),
              );
              break;
            }

            default: {
              break;
            }
          }
        };

        const handleSyncUserCredits = () => {
          const {
            bonusCharacters: updatedBonusCharacters,
            remainingCharacters: updatedRemainingCharacters,
            studio,
          } = result;

          // Update user info
          dispatch(
            actions.auth.updateUserInfo({
              bonusCharacters: updatedBonusCharacters,
              remainingCharacters: updatedRemainingCharacters,
              studio: {
                ...studio,
                cycle: {
                  ...studio?.cycle,
                  remainingCredits: studio?.cycle?.remainingCredits,
                },
                custom: {
                  ...studio?.custom,
                  remainingCredits: studio?.custom?.remainingCredits,
                },
              },
            }),
          );

          // Update tts user
          dispatch(
            actions.user.getTtsUserSuccess({
              ...ttsUserRef.current,
              bonusCharacters: updatedBonusCharacters,
              remainingCharacters: updatedRemainingCharacters,
              studio: {
                ...ttsUserRef.current.studio,
                cycle: {
                  ...ttsUserRef.current?.studio?.cycle,
                  remainingCredits: studio?.cycle?.remainingCredits,
                  capturedReferralCredits:
                    studio?.cycle?.capturedReferralCredits,
                },
                custom: {
                  ...ttsUserRef.current?.studio?.custom,
                  remainingCredits: studio.custom?.remainingCredits,
                  capturedReferralCredits:
                    studio?.custom?.capturedReferralCredits,
                },
                oneTime: {
                  ...ttsUserRef.current?.studio?.oneTime,
                  capturedReferralCredits:
                    studio?.oneTime?.capturedReferralCredits,
                },
              },
            }),
          );
        };

        const handleSyncWalletCredits = () => {
          const { wallets } = result;

          const {
            oneTime: oneTimeCredits,
            cycle: cycleCredits,
            topUp: topUpCredits,
            custom: customCredits,
            bonus: bonusCredits,
          } = wallets;

          // Update user info
          dispatch(
            actions.auth.updateUserInfo({
              ...userRef.current,
              bonusCharacters: bonusCredits,
              remainingCharacters: oneTimeCredits,
              studio: {
                ...userRef.current?.studio,
                cycle: {
                  ...userRef.current?.studio?.cycle,
                  remainingCredits: cycleCredits,
                },
                custom: {
                  ...userRef.current?.studio?.custom,
                  remainingCredits: customCredits,
                },
                topUp: {
                  ...userRef.current?.studio?.topUp,
                  remainingCredits: topUpCredits,
                },
              },
            }),
          );

          // Update tts user
          dispatch(
            actions.user.getTtsUserSuccess({
              ...ttsUserRef.current,
              bonusCharacters: bonusCredits,
              remainingCharacters: oneTimeCredits,
              studio: {
                ...ttsUserRef.current.studio,
                cycle: {
                  ...ttsUserRef.current?.studio?.cycle,
                  remainingCredits: cycleCredits,
                },
                custom: {
                  ...ttsUserRef.current?.studio?.custom,
                  remainingCredits: customCredits,
                },
                topUp: {
                  ...ttsUserRef.current?.studio?.topUp,
                  remainingCredits: topUpCredits,
                },
              },
            }),
          );
        };

        const syncAccountLogout = ({ clientId, fingerprint, redirectUri }) => {
          const fingerprintClient =
            localStorage.getItem('fingerprint-v2') || '';

          const isMatchingDevice = fingerprintClient === fingerprint;
          const isMatchingClient = clientId
            ? ALLOWED_CLIENT_IDS.includes(clientId)
            : true;

          if (isMatchingDevice && isMatchingClient) {
            window.location.href = redirectUri || LANDING_PAGE_URL;
          }
        };

        const handleInstantVoiceTraining = ({
          voiceId,
          status,
          sampleLink,
        }) => {
          dispatch(
            actions.instantVoiceTraining.addInstantVoiceTraining({
              voiceId,
              status,
              sampleLink,
            }),
          );
        };

        const handleTaskCompleted = () => {
          const completedTask = result?.task;
          trackOnboardingTaskCompleted(completedTask);
          dispatch(
            actions.layout.setTaskCompletedData({
              ...completedTask,
            }),
          );
        };

        switch (type) {
          case WS_TYPE.SYNTHESIS: {
            handleSynthesis();
            break;
          }

          case WS_TYPE.INIT: {
            updateUserInfo(true);
            break;
          }

          case WS_TYPE.ORDER: {
            handleOrder();
            break;
          }

          case WS_TYPE.SYNC_USER_CREDITS: {
            handleSyncUserCredits();
            break;
          }

          case WS_TYPE.SYNC_WALLET_CREDITS: {
            handleSyncWalletCredits();
            break;
          }

          case WS_TYPE.LOGOUT_DEVICES: {
            const { fingerprint } = result;
            dispatch(
              actions.device.addDeviceResponse({
                fingerprint,
                status: DEVICE_STATUS.OFFLINE,
              }),
            );
            handleLogout(fingerprint);
            break;
          }

          case WS_TYPE.AFFILIATE_NOTIFICATION: {
            handleAffiliateNotification();
            break;
          }

          case WS_TYPE.RESET_FREE_CHARACTERS: {
            dispatch(
              actions.auth.updateBonusCharacters(result.bonusCharacters),
            );
            dispatch(
              actions.user.updateBonusCharacters(result.bonusCharacters),
            );
            break;
          }

          case WS_TYPE.PUSH_ORDER_TO_GTM: {
            sendOrderToGTM(result);
            break;
          }

          case WS_TYPE.SYNC_ACCOUNT_LOGOUT: {
            const { clientId, fingerprint, redirectUri } = result;
            syncAccountLogout({ clientId, fingerprint, redirectUri });
            break;
          }

          case WS_TYPE.INSTANT_VOICE_TRAINING: {
            const { voiceId, status, sampleLink } = result;
            handleInstantVoiceTraining({ voiceId, status, sampleLink });
            break;
          }

          case WS_TYPE.TASK_COMPLETED: {
            handleTaskCompleted();
            break;
          }

          default:
            break;
        }
      };

      ws.current.onclose = (event) => {
        const { code, reason, wasClean } = event;
        // eslint-disable-next-line no-console
        console.log('Websocket is closed.', { event, code, reason, wasClean });
        clearInterval(pingInterval);
        createNotificationWSConnection();
      };
    };

    // Initialize WebSocket connection
    createNotificationWSConnection();

    return () => {
      // Clean up on component unmount
      ws.current?.close();
    };
  }, []);

  useEffect(() => {
    if (!hasFinishedOnboarding) return;

    if (isUserEligible === undefined) return;

    if (appliedReferralErrorMessage) {
      dispatch(actions.user.updateIsOpeningRedeemReferralDialog(true));
      return;
    }

    if (isUserEligible) {
      // Only open reward dialog if user has reward credits
      setOpenRewardDialog(rewardCredits > 0);
      return;
    }

    dispatch(actions.user.openReferralErrorNotiPopup());
  }, [hasFinishedOnboarding, isUserEligible, appliedReferralErrorMessage]);

  useEffect(() => {
    const checkUserEligibility = async () => {
      const isEligible = await handleCheckUserEligibility();
      setIsUserEligible(isEligible);
      if (isEligible) {
        await handleApplyReferral();
      }
    };

    if (autoApplyReferral) {
      checkUserEligibility();
    } else {
      handleReferralCodeFromURL();
    }
  }, [autoApplyReferral]);

  useEffect(() => {
    fetchCountry();
    fetchReferralConfig();
  }, []);

  useEffect(() => {
    if (!banners.length) return;
    // Handle receive subscription redirect result
    const { purchaseId, status, registerAutoRenew } = camelcaseKeys(
      queryString.parse(location.search) || {},
    );
    if (purchaseId) {
      fetchSubscriptionPurchase(purchaseId, status, registerAutoRenew);
    }
  }, [location, banners]);

  useEffect(() => {
    handleOpenRequiredEmailDialogAt();
  }, [
    hasFinishedOnboarding,
    isUserEligible,
    autoApplyReferral,
    appliedReferralErrorMessage,
    openRewardDialog,
    userInfo.isOpeningReferralErrorNotiPopup,
    userInfo.isOpeningRedeemReferralDialog,
  ]);

  const isBackgroundWhiteMobile = [
    ROUTES.VOICE_CLONING_VOICES,
    ROUTES.REFERRAL,
  ].includes(location.pathname);

  const newPricingOverviewEnabled = getFeatureValue(
    FEATURE_KEYS.NEW_PRICING_OVERVIEW,
    {
      ip,
      userId: user?.id,
      email: user?.email,
      phoneNumber: user?.phoneNumber,
    },
  );

  const isPricingPage =
    newPricingOverviewEnabled &&
    [ROUTES.PAYMENT].includes(location.pathname) &&
    !location.search.includes('package');

  // Pages that own their full-bleed white canvas instead of sitting on the
  // default layout background.
  const isWhiteBackgroundPage =
    isPricingPage ||
    isEducatorsRoute ||
    location.pathname === ROUTES.TOP_PAID_EVENT;

  useEffect(() => {
    if (
      ttsUser &&
      ttsUser?.migratedDubbing &&
      !ttsUser?.migratedDubbing?.hasAgreedToMigrate
    )
      setHasAgreedToMigrateDubbing(false);

    if (ttsUser && ttsUser?.id) {
      const hasAgreedToMigrateOldPkgToV3 = localStorage.getItem(
        `hasAgreeToMigrateToV3-${ttsUser?.id}`,
      );
      if (!hasAgreedToMigrateOldPkgToV3) {
        setHasAgreeToMigrateToV3(false);
      }
    }
  }, [ttsUser]);

  // Handle auto renew price adjustment popup
  const {
    canShowPopup,
    usingStudioOrder,
    releaseTime,
    applyNewPriceAfterDays,
  } = useAutoRenewPriceAdjustment() || {};
  useEffect(() => {
    const hasAgreedToAutoRenewPriceAdjustmentPopup = localStorage.getItem(
      `hasAgreeToAutoRenewPriceAdjustmentPopup-${user?.id}`,
    );
    if (canShowPopup && !hasAgreedToAutoRenewPriceAdjustmentPopup) {
      setShowAutoRenewPriceAdjustmentPopup(true);
    }
  }, [canShowPopup, user?.id]);

  const renderReferralDialog = () => (
    <>
      <RedeemDialog
        appliedReferralErrorMessage={appliedReferralErrorMessage}
        referralCode={referralCode}
        rewardCredits={rewardCredits}
        openRewardDialog={openRewardDialog}
        setOpenRewardDialog={setOpenRewardDialog}
      />
      <ReferralErrorDialog referralCode={referralCode} />
    </>
  );

  const renderActionTypography = () => {
    const pathPayment = getPathPaymentWhenNotifyLowCredits(
      usingPackage,
      packages,
    );
    const onClick = () => history.push(pathPayment);

    const isFreePackage = FREE_PACKAGE_CODES.includes(usingPackage?.code);
    if (isFreePackage) {
      return (
        <CustomTypography
          variant="body-14-regular"
          color={COLOR.white}
          style={{
            textDecoration: 'underline',
          }}
          onClick={onClick}
        >
          {t('upgradeNow')}
        </CustomTypography>
      );
    }
    const isCustomPackage = checkCustomPackage({
      type: usingPackage?.type,
      level: usingPackage.level,
    });
    if (isCustomPackage) {
      return (
        <CustomTypography
          variant="body-14-regular"
          color={COLOR.white}
          style={{
            textDecoration: 'underline',
          }}
          onClick={onClick}
        >
          {t('renewalNow')}
        </CustomTypography>
      );
    }
    const isOneTimePackage = checkOneTimePackage(usingPackage?.version);
    if (isOneTimePackage) {
      return (
        <CustomTypography
          variant="body-14-regular"
          color={COLOR.white}
          style={{
            textDecoration: 'underline',
          }}
          onClick={onClick}
        >
          {t('buyNow')}
        </CustomTypography>
      );
    }
    return (
      <CustomTypography
        variant="body-14-regular"
        color={COLOR.white}
        style={{
          textDecoration: 'underline',
        }}
        onClick={onClick}
      >
        {t('buyMoreCharacters')}
      </CustomTypography>
    );
  };

  const renderContent = () => {
    if (!ipLocation) return <ProcessHandler loading={!location} />;
    if (
      ipLocation &&
      isExceedDevices &&
      location?.pathname !== ROUTES.MANAGE_DEVICE
    )
      return (
        <>
          <StyledWrapper>
            <NewSidebar
              openSidebar={openSidebar}
              handleOpenSidebar={handleOpenSidebar}
              handleCloseSidebar={handleCloseSidebar}
              ipLocation={ipLocation}
            />

            <StyledMainPanel
              className={classNames({ 'open-sidebar': openSidebar })}
            >
              <NewNavbar
                openSidebar={openSidebar}
                handleOpenSidebar={handleOpenSidebar}
                ipLocation={ipLocation}
              />

              <Content
                openSidebar={openSidebar}
                newPricingOverviewEnabled={newPricingOverviewEnabled}
              >
                <NotificationDialog
                  name="exceed-devices"
                  width="566px"
                  hiddenIcon
                  dialogDevice
                  title={t('accountDeviceExceedTitle')}
                  contentComponent={
                    <NewManageDevice
                      isPopup
                      dialogDevice
                      isExceedDevices={isExceedDevices}
                      checkUserDevice={checkUserDeviceV2}
                    />
                  }
                  open={isExceedDevices}
                />
              </Content>
            </StyledMainPanel>
          </StyledWrapper>
        </>
      );

    if (isFetchingSignUpSurvey) {
      return (
        <Box
          height="100vh"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress color="primary" />
        </Box>
      );
    }

    if (isDisplaySignUpSurvey) {
      return (
        <>
          {renderReferralDialog()}
          <NotificationDialog
            hiddenIcon
            contentComponent={
              <Survey
                closeUserSurvey={handleUpdateUserSurvey}
                steps={userSurvey?.signup?.steps}
              />
            }
            open
          />
        </>
      );
    }

    // The tasks take the whole page, so a teacher who has just arrived gets the
    // welcome board first and these once it closes.
    if (showOnboardingTasks && !isMobile && !isEducatorsQueueRunning) {
      return (
        <OnboardingTasks
          onboardingTask
          onClose={() => dispatch(actions.layout.setShowOnboardingTasks(false))}
        />
      );
    }

    return (
      <>
        <StyledWrapper headerVoucher={headerVoucher}>
          <NewSidebar
            useHeaderBanner
            headerVoucher={headerVoucher}
            openSidebar={openSidebar}
            handleOpenSidebar={handleOpenSidebar}
            handleCloseSidebar={handleCloseSidebar}
            ipLocation={ipLocation}
          />

          <StyledMainPanel
            openSidebar={openSidebar}
            isBackgroundWhiteMobile={isBackgroundWhiteMobile}
            isWhiteBackgroundPage={isWhiteBackgroundPage}
            className="main-panel"
            withPaneluseMultiBlockUIV2={isDetailProjectPage && 96}
          >
            <NewNavbar
              openSidebar={openSidebar}
              handleOpenSidebar={handleOpenSidebar}
              ipLocation={ipLocation}
            />

            <Content
              headerVoucher={headerVoucher}
              openSidebar={openSidebar}
              newPricingOverviewEnabled={newPricingOverviewEnabled}
            >
              <TitleProduct />
              {showPackageExpiringSoonBanner && (
                <StyledWrapperExpiringSoon>
                  <div>
                    <CustomTypography
                      variant="body-14-regular"
                      color={COLOR.white}
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: t('infoExpiringSoon', {
                          days:
                            moment(user?.packageExpiryDate).diff(
                              moment(),
                              'days',
                            ) + 1,
                          paramsExpiringSoon: getParamsExpiringSoon(
                            usingPackage,
                            packages,
                          ),
                        }),
                      }}
                    />{' '}
                    <CustomTypography
                      variant="body-14-regular"
                      color={COLOR.white}
                      style={{
                        textDecoration: 'underline',
                      }}
                      onClick={() => {
                        const paramsExpiringSoon = getParamsExpiringSoon(
                          usingPackage,
                          packages,
                        );
                        history.push(
                          userUseOneTimePackage
                            ? `${ROUTES.PAYMENT}`
                            : `${ROUTES.PAYMENT}?${paramsExpiringSoon}`,
                        );
                      }}
                    >
                      {userUseOneTimePackage ? t('buyNow') : t('renewNow')}
                    </CustomTypography>
                  </div>
                  <CloseRoundedIcon
                    sx={{ fontSize: 16, color: COLOR.white }}
                    onClick={() =>
                      dispatch(actions.layout.setShowPackageExpiringSoon(false))
                    }
                  />
                </StyledWrapperExpiringSoon>
              )}
              {showNotifyLowCreditsBanner && !showPackageExpiringSoonBanner && (
                <StyledWrapperExpiringSoon>
                  <div>
                    <CustomTypography
                      variant="body-14-regular"
                      color={COLOR.white}
                    >
                      {t('lowCharacters')}!
                    </CustomTypography>{' '}
                    {renderActionTypography()}
                  </div>
                  <CloseRoundedIcon
                    sx={{ fontSize: 16, color: COLOR.white }}
                    onClick={() =>
                      dispatch(actions.layout.setShowNotifyLowCredits(false))
                    }
                  />
                </StyledWrapperExpiringSoon>
              )}
              {children}
            </Content>
          </StyledMainPanel>
          <Banners banners={banners} onChangeBanners={handleChangeBanners} />
          <EventWidget />
          {renderReferralDialog()}
          {notificationDialog?.open && (
            <NotificationDialog
              name={notificationDialog.name}
              title={notificationDialog.title}
              description={notificationDialog.description}
              subDescription={notificationDialog.subDescription}
              variant={notificationDialog.variant}
              open={notificationDialog.open}
              width={notificationDialog.width}
              contentComponent={notificationDialog.contentComponent}
              actionComponent={notificationDialog.actionComponent}
              onClose={notificationDialog.onClose}
            />
          )}
          {showMigrateToV3Popup && (
            <NotificationDialogV4
              isPopupTransfer
              image={TransferIcon}
              hideImageOnMobileWeb
              title={t('announcementUpperCase')}
              contentPopup={
                <ContentTransferPackage
                  setHasAgreeToMigrateToV3={setHasAgreeToMigrateToV3}
                />
              }
              open={!hasAgreeToMigrateToV3}
              showIconClose={false}
            />
          )}
          <AutoRenewDialog
            open={showAutoRenewalBanner}
            onClose={handleCloseAutoRenewDialog}
          />
        </StyledWrapper>
        {isVisible && (
          <LimitedFeaturesDialog
            open={isVisible}
            title={title}
            description={description}
            onUpgrade={onUpgrade}
            onClose={onClose}
            img={img}
            classNameImg={classNameImg}
            maxWidth={maxWidth}
            showButtonUnderstand={showButtonUnderstand}
            showBlurBackground={showBlurBackground}
            showOnlyUnderstandButton={showOnlyUnderstandButton}
            paywall={limitedFeaturePaywall}
          />
        )}
        <OnboardingPopup
          open={isOnboardingPopupVisible && !isOnboardingPopupHeldBack}
          onClose={() =>
            dispatch(actions.onboardingPopup.hideOnboardingPopup())
          }
          type={onboardingPopupType}
        />
        {isCancelReasonDialogVisible && (
          <CancelReasonDialog open={isCancelReasonDialogVisible} />
        )}
        {!hasAgreedToMigrateDubbing && (
          <MigratedDubbingDialog
            open={!hasAgreedToMigrateDubbing}
            onClose={() => setHasAgreedToMigrateDubbing(true)}
          />
        )}
        {notificationDialogV2?.open && (
          <NotificationDialogV3
            name={notificationDialogV2?.name || 'notification-dialog-v2'}
            title={notificationDialogV2?.title}
            description={notificationDialogV2?.description}
            variant={notificationDialogV2?.variant}
            open={notificationDialogV2?.open}
            width={notificationDialogV2?.width}
            fitWidth={notificationDialogV2?.fitWidth}
            widthContent={notificationDialogV2?.widthContent}
            maxWidth={notificationDialogV2?.maxWidth}
            actionComponent={notificationDialogV2?.actionComponent}
            onClose={notificationDialogV2?.onClose || (() => {})}
          />
        )}
        {emailRequiredEnabled && openRequireProvideEmailDialog && (
          <RequireProvideEmailDialog
            open={openRequireProvideEmailDialog}
            onClose={() => setOpenRequireProvideEmailDialog(false)}
          />
        )}

        {/* Onboarding popup */}
        <CommonDialog
          showBlurBackground
          open={showOnboardingPopup && !isEducatorsQueueRunning}
          width="712px"
          styleContent={{
            padding: '24px',
            overflowX: 'hidden !important',
          }}
          disableAutoClose
          PaperProps={{
            sx: {
              height: '640px',
            },
          }}
          onClose={() => {
            dispatch(actions.layout.setShowOnboardingPopup(false));
          }}
          contentComponent={<Tasks fromPopup />}
          title={t('titlePopupOnboardingTasks')}
        />

        {/* Finishing the signup survey earns a reward the moment the teacher
            lands in Educators, so this waits out the welcome board and the
            Educators survey rather than landing on top of them. */}
        {taskCompletedData && !isEducatorsQueueRunning && (
          <PopupCompleteTask
            open={taskCompletedData}
            onClose={() => {
              dispatch(actions.layout.setTaskCompletedData(null));
            }}
          />
        )}

        {/* Rides on showOnboardingTasks, which is set on desktop too, so it
            needs the same hold as the full-page tasks behind it. */}
        {(showOnboardingPopupMobile || showOnboardingTasks) &&
          !isEducatorsQueueRunning && (
            <OnboardingDrawer
              open={showOnboardingPopupMobile || showOnboardingTasks}
              onClose={() => {
                dispatch(actions.layout.setShowOnboardingPopupMobile(false));
                dispatch(actions.layout.setShowOnboardingTasks(false));
              }}
            />
          )}

        <HightLightWeek
          open={
            openHighlightWeekDialog &&
            !isUserCreatedToday &&
            !isEducatorsQueueRunning
          }
          onClose={handleClose}
        />
        <AutoRenewPriceAdjustmentPopup
          open={showAutoRenewPriceAdjustmentPopup && !isEducatorsQueueRunning}
          onClose={() => {
            localStorage.setItem(
              `hasAgreeToAutoRenewPriceAdjustmentPopup-${user?.id}`,
              true,
            );
            setShowAutoRenewPriceAdjustmentPopup(false);
          }}
          releaseTime={releaseTime}
          usingStudioOrder={usingStudioOrder}
          applyNewPriceAfterDays={applyNewPriceAfterDays}
        />
      </>
    );
  };

  return (
    <>
      {renderContent()}
      <ServiceTerm
        open={openServiceTerm}
        onClose={() => setOpenServiceTerm(false)}
      />
    </>
  );
};

export default Layout;
